import './AlertMessage.scss'
import {useEffect, useRef} from "react";


export default function ErrorMessage({text, type, show}) {
    const refAlert = useRef()

    useEffect(() => {
        if (show) {

        }
    }, [show])

    return (
        <div ref={refAlert} className={'errorMessage ' + (show ? 'show' : '')} type={type}>
            <div className="image_alert_message"></div>
            <p>{text}</p>
        </div>
    )
}